import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for a single open-ended question
 */
export interface OpenEndedQuestion {
  question_content: string;
  image: string;
  description: string;
  question_type: 'open_ended';
  points_obtainable: number;
  required: boolean;
  word_limit: number;
}

/**
 * Interface for open-ended question payload
 */
export interface OpenEndedQuestionPayload {
  assessment_id: string;
  question1: OpenEndedQuestion | null;
  question2: OpenEndedQuestion | null;
  question3: OpenEndedQuestion | null;
}

/**
 * Hook for posting open-ended questions using TanStack React Query
 */
export const useOpenEndedQuestionPost = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: OpenEndedQuestionPayload) => {
      const response = await apiClient.post('/assessment/open-ended-question/', payload);
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: "Success",
        text: "Open-ended question(s) created successfully!",
        type: "info",
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to submit open-ended questions';
      openToast({
        show: true,
        heading: "Submission Failed",
        text: errorMessage,
        type: "error",
        timeOut: 5000,
      });
    },
  });
};

